import { Api } from '@shared/api/Api';

export class RIANotifications {
    private static _basePath = '/RIANotification';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${RIANotifications._basePath}`;
        return {
            async riaNotifications(accountId: number, page: number, pageSize: number) {
                const path = `/riaNotifications?userId=${accountId}&page=${page}&pageSize=${pageSize}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },

            async updateNotification(body: any) {
                const path = '/updateNotification';
                return await Api.put<string>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
        };
    }
}
